module.exports = __webpack_public_path__ + "static/img/gd4.f8fc23f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/gd4.jpg
// module id = 300
// module chunks = 34